import * as Mutations from "@/store/mutations.type";

export default {
  [Mutations.SET_BLOG_OPERATION](state, status) {
    state.operation = status;
  },
  [Mutations.SET_BLOG_COMPONENT_ATTR](state, { attr, index }) {
    state.blogComponentAttrs[index] = attr;
  },
  [Mutations.SET_BLOG_COMPONENT_LOADING](state, { status, index }) {
    state.blogComponentLoading[index] = status;
  },
  [Mutations.SET_BLOG_SELECTED_INSTANCE](state, { instanceId, index }) {
    state.blogSelectedInstance[index] = instanceId;
  },
  [Mutations.SET_INSTANCE_CREATE_LOADING](state, status) {
    state.instanceCreateLoading = status;
  },
  [Mutations.SET_INSTANCE_COPY_LOADING](state, status) {
    state.instanceCopyLoading = status;
  },
  [Mutations.SET_INSTANCE_EDIT_LOADING](state, status) {
    state.instanceEditLoading = status;
  },
  // component instance info
  [Mutations.SET_BLOG_COMPONENT_INSTANCE](state, { instance, componentId }) {
    state.blogComponentInstances[componentId] = instance;
  },
  [Mutations.SET_BLOG_INSTANCE_LOADING](state, { status, componentId }) {
    state.blogComponentInstancesLoading[componentId] = status;
  },
  [Mutations.SET_BLOG_ERROR](state, error) {
    state.error = error;
  },
  [Mutations.SET_BLOG_SUCCESS](state, success) {
    state.success = success;
  },
  // clear redundant cache
  [Mutations.CLEAR_BLOG_COMPONENT_ATTR](state) {
    state.blogComponentAttrs = [];
  },
  [Mutations.CLEAR_BLOG_COMPONENT_LOADING](state) {
    state.blogComponentLoading = [];
  },
  [Mutations.CLEAR_BLOG_SELECTED_INSTANCE](state) {
    state.blogSelectedInstance = [];
  },
  [Mutations.DELETE_SELECTED_INSTANCE](state, { index }) {
    state.blogSelectedInstance.splice(index, 1);
  },
  [Mutations.DELETE_COMPONENT_ATTRIBUTE](state, { index }) {
    state.blogComponentAttrs.splice(index, 1);
  }
};
